import type { AxiosError } from "axios";
import { worktimeApi } from "@wkt/api/worktime";
import type {
  BaseMessageDTO,
  FullNewsDTO,
  FullSurveyDTO,
  FullUserMessageDTO,
  WeatherInfoDTO,
} from "./homeDTO";

type SuccessCallback<T = unknown> = (data: T) => void;
type ErrorCallback = (error: AxiosError) => void;

export class HomeAPI {
  getMessages(
    onSuccess: SuccessCallback<FullUserMessageDTO[]>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericGet("user/message", onSuccess, onError);
  }

  getCurrentNews(
    employeeId: number,
    onSuccess: SuccessCallback<FullNewsDTO[]>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericGet(`user/news/${employeeId}`, onSuccess, onError);
  }

  getCurrentSurveys(
    onSuccess: SuccessCallback<FullSurveyDTO[]>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericGet("user/survey", onSuccess, onError);
  }

  getWeatherInfo(
    onSuccess: SuccessCallback<WeatherInfoDTO>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericGet("user/weatherInfo", onSuccess, onError);
  }

  deleteMessage(
    messageId: number,
    onSuccess: SuccessCallback<void>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericDelete(`user/message/${messageId}`, onSuccess, onError);
  }

  respondMessage(
    message: FullUserMessageDTO,
    onSuccess: SuccessCallback<void>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericPost("user/message", message, onSuccess, onError);
  }

  publishMessage(
    message: BaseMessageDTO,
    onSuccess: SuccessCallback<void>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericPost("user/publishMessage", message, onSuccess, onError);
  }

  replyMessage(
    originalMessageId: number,
    message: BaseMessageDTO,
    onSuccess: SuccessCallback<void>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericPost(`user/replyMessage/${originalMessageId}`, message, onSuccess, onError);
  }

  getNewsById(
    newsId: number,
    onSuccess: SuccessCallback<FullNewsDTO>,
    onError: ErrorCallback,
  ): void {
    worktimeApi.genericGet(`user/news-by-id/${newsId}`, onSuccess, onError);
  }
}

export const homeApi = new HomeAPI();
export default homeApi;
